// Extended detail per service — tiers, case studies, deliverables
export const SERVICE_DETAILS = {
  website: {
    longDesc:
      "Beautiful, high-performance websites that convert. We handle strategy, UX, design, development, and 24/7 maintenance so your brand looks and works its best on every device.",
    deliverables: [
      "UX & information architecture",
      "Design in Figma with stakeholder demos",
      "Fully responsive development",
      "SEO & Core Web Vitals optimisation",
      "24/7 monitoring & security",
    ],
    tiers: [
      {
        name: "One-Page",
        price: "From ₹14,999",
        blurb: "For focused campaigns and personal brands.",
        features: ["Single high-converting page", "Mobile-responsive", "Basic SEO", "1 revision"],
      },
      {
        name: "5+ Page",
        price: "From ₹34,999",
        blurb: "For growing businesses that need credibility.",
        features: ["5+ dedicated pages", "SEO-ready structure", "CMS content", "3 revisions"],
        highlight: true,
      },
      {
        name: "Custom",
        price: "Talk to us",
        blurb: "Complex builds, integrations & platforms.",
        features: ["Custom UI/UX", "API & CMS integrations", "Performance & security", "Ongoing partnership"],
      },
    ],
    caseStudies: [
      {
        client: "Bharat Handloom Co.",
        industry: "Retail",
        result: "3.2× online orders in 90 days after a full rebrand + storefront redesign.",
      },
      {
        client: "Sunrise Nursing Group",
        industry: "Healthcare",
        result: "Lead volume grew 210% with a fast, credibility-first multi-page site.",
      },
    ],
  },
  software: {
    longDesc:
      "Custom Android, iOS and web platforms engineered around your business logic. We ship maintainable code, ship fast, and stay after launch.",
    deliverables: [
      "Product discovery & scoping",
      "Native or cross-platform builds",
      "APIs & third-party integrations",
      "QA, CI/CD & release engineering",
      "Post-launch SLAs",
    ],
    tiers: [
      { name: "MVP", price: "From ₹1.5L", blurb: "Ship a validated MVP in 8–12 weeks.", features: ["Product blueprint", "Core flows", "Auth & payments", "Analytics"] },
      { name: "Scale", price: "From ₹6L", blurb: "Full app + admin + integrations.", features: ["iOS + Android + web", "Admin dashboard", "3rd-party APIs", "3 months support"], highlight: true },
      { name: "Enterprise", price: "Talk to us", blurb: "Dedicated squad, long-term.", features: ["Dedicated engineers", "Architecture review", "Security & compliance", "SLA-backed uptime"] },
    ],
    caseStudies: [
      { client: "FieldForce Logistics", industry: "SaaS · Logistics", result: "Cut route-planning time by 68% with a custom driver-first Android app." },
      { client: "RupeeLoop", industry: "Fintech", result: "Launched a P2P lending MVP in 10 weeks, onboarded 3,400 users in month one." },
    ],
  },
  rpo: {
    longDesc:
      "Smart, scalable Recruitment Process Outsourcing. We source, screen and place elite talent — from single senior hires to entire delivery teams.",
    deliverables: [
      "Role scoping & JD engineering",
      "Sourcing across LinkedIn / Naukri / referrals",
      "Structured screening interviews",
      "Employer branding & candidate experience",
      "Offer negotiation & onboarding support",
    ],
    tiers: [
      { name: "Single Hire", price: "8.33% CTC", blurb: "Great for critical senior roles.", features: ["Retained search", "5 vetted shortlists", "45-day replacement"] },
      { name: "Team Build", price: "From ₹2L/mo", blurb: "Ramp 5–20 hires per quarter.", features: ["Dedicated recruiter pod", "Weekly reporting", "Employer branding"], highlight: true },
      { name: "Enterprise RPO", price: "Custom", blurb: "End-to-end talent function.", features: ["Full RPO ownership", "ATS integration", "SLA & analytics"] },
    ],
    caseStudies: [
      { client: "GlobalCare BPO", industry: "BPO", result: "Placed 240 CS reps in 90 days across 3 Indian metros." },
      { client: "Nordic Health", industry: "EU Healthcare", result: "Sourced 45 German-certified nurses from Jharkhand under an ethical corridor." },
    ],
  },
  bpo: {
    longDesc:
      "Customer support, tech helpdesks and back-office ops delivered by trained teams at global quality standards — and cost-per-seat that actually makes sense.",
    deliverables: [
      "Voice / chat / email support",
      "Level-1 / Level-2 tech helpdesk",
      "Data entry & back-office ops",
      "Quality assurance & CSAT tracking",
      "Multilingual: EN, HI + regional",
    ],
    tiers: [
      { name: "Pilot Seat", price: "From ₹28k/seat/mo", blurb: "Test a 5-seat pilot for 3 months.", features: ["24×5 support", "Trained agents", "Weekly reports"] },
      { name: "Growth Pod", price: "From ₹22k/seat/mo", blurb: "10–50 seats, 24×7 coverage.", features: ["Dedicated pod", "TL + QA", "CSAT dashboards"], highlight: true },
      { name: "Full Contact Center", price: "Custom", blurb: "100+ seats, multi-shift.", features: ["Multi-site coverage", "IVR & CRM integration", "SLA + BCP"] },
    ],
    caseStudies: [
      { client: "ShopSmart", industry: "D2C", result: "Reduced customer response time from 12h to 22min while cutting cost 34%." },
      { client: "LogiNet", industry: "Logistics", result: "Ran a 60-seat 24×7 dispatch helpdesk with 96% CSAT." },
    ],
  },
  pr: {
    longDesc:
      "Strategic PR that builds trust and shapes perception — media outreach, press releases, influencer collabs and crisis management.",
    deliverables: [
      "Media strategy & positioning",
      "Press release drafting & distribution",
      "Journalist / editor outreach",
      "Influencer & thought-leadership programs",
      "Crisis response playbooks",
    ],
    tiers: [
      { name: "Launch Push", price: "From ₹75k", blurb: "One big announcement, done right.", features: ["Press kit", "Targeted outreach", "3–5 placements target"] },
      { name: "Always-On", price: "From ₹1.25L/mo", blurb: "Ongoing coverage & thought leadership.", features: ["Monthly narrative plan", "Bylined articles", "Media relations"], highlight: true },
      { name: "Enterprise PR", price: "Custom", blurb: "Multi-market, global press coverage.", features: ["Global newswire", "Executive positioning", "Crisis retainer"] },
    ],
    caseStudies: [
      { client: "GreenGrid Energy", industry: "Cleantech", result: "Landed 22 tier-1 features (ET, YourStory, Inc42) around funding round." },
      { client: "Aveena Beauty", industry: "D2C", result: "Grew founder Instagram to 148k followers via press + influencer program." },
    ],
  },
  digital: {
    longDesc:
      "SEO, paid ads, content and email — data-backed campaigns that turn clicks into customers and traffic into pipeline.",
    deliverables: [
      "SEO audit & content strategy",
      "Google & Meta paid campaigns",
      "Conversion-rate optimisation",
      "Email & CRM automation",
      "Weekly performance reporting",
    ],
    tiers: [
      { name: "Kickstart", price: "From ₹45k/mo", blurb: "For small brands and local businesses.", features: ["1 channel focus", "10 keywords SEO", "Ad management up to ₹1L spend"] },
      { name: "Growth", price: "From ₹1L/mo", blurb: "Multi-channel, real pipeline.", features: ["SEO + paid + email", "Landing pages", "Weekly reviews"], highlight: true },
      { name: "Performance", price: "Custom", blurb: "Aggressive scale + attribution.", features: ["Full-funnel", "MMM / attribution", "Dedicated strategist"] },
    ],
    caseStudies: [
      { client: "BharatBites", industry: "D2C Foods", result: "5.2× ROAS on Meta ads with a full-funnel content + retargeting play." },
      { client: "PropStack", industry: "Real Estate", result: "Grew organic leads 3.4× in 6 months via topical SEO clusters." },
    ],
  },
  social: {
    longDesc:
      "Instagram, LinkedIn, YouTube and beyond — scroll-stopping content, targeted campaigns and communities that convert.",
    deliverables: [
      "Content strategy & calendar",
      "Reels, shorts & long-form video",
      "Influencer partnerships",
      "Community management",
      "Paid social amplification",
    ],
    tiers: [
      { name: "Starter", price: "From ₹35k/mo", blurb: "One platform, done properly.", features: ["12 posts + 4 reels", "Community reply SLA", "Monthly review"] },
      { name: "Multi-Channel", price: "From ₹85k/mo", blurb: "IG + LinkedIn + YouTube shorts.", features: ["30+ pieces / month", "Influencer collabs", "Ad amplification"], highlight: true },
      { name: "Full Studio", price: "Custom", blurb: "Video-first brand studio.", features: ["Dedicated content producer", "Founder / exec branding", "Paid + organic mix"] },
    ],
    caseStudies: [
      { client: "Rooted Wellness", industry: "Wellness D2C", result: "Grew Instagram from 4k → 92k in 6 months with a Reels-first strategy." },
      { client: "NextGen Academy", industry: "Edtech", result: "LinkedIn thought leadership drove 1,200 qualified signups in 90 days." },
    ],
  },
};
